<template>
  <div class="layout-home-root">
    <!-- 头部导航栏 -->
    <!-- <div class="topnav" v-show="topnavShow">
      <router-link><div class="logo"></div> </router-link>
      <div class="router-bar">

      </div>
    </div> -->

    <!-- 页面滚动部分 -->
    <router-view v-slot="{ Component }">
      <transition name="fade-transform" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance } from "vue";
import { apiGetUserInfo, apiGetUserInfoWithRedirt } from "@/Api/AppApi";
import { useTechStore } from "@/Store/TechStore";
import { useProjectStore } from "@/Store/ProjectStore";
import { removeToken } from "@/Utils/Auth";
import * as Settings from "@/settings";

const projectStore = useProjectStore();
const techStore = useTechStore();
const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const bus = appContext.config.globalProperties.bus;

const topnavShow = ref(true);
bus.on("change-topnav-state", (val) => {
  topnavShow.value = val;
});

const isOffline = ref(true);
const username = ref("");

if (techStore.userInfo === null) {
  (async function () {
    const res = await apiGetUserInfo();
    if (res.code === 0) {
      if (res.data !== null) {
        isOffline.value = false;
        username.value = `${res.data.fullname}(${res.data.username})`;

        techStore.changeUserInfo(res.data);
      }
    } else {
      if(res.message.indexOf("40") === -1){
        $message.error(res.message);
      }

    }
  })();
} else {
  const userInfo = techStore.userInfo;
  isOffline.value = false;
  username.value = `${userInfo.fullname}(${userInfo.username})`;
}

function handleLogin() {
  apiGetUserInfoWithRedirt();
}

async function handleLogout() {
  // 通过清空cookie退出登录
  removeToken();

  // store 状态和组件状态清空
  isOffline.value = true;
  username.value = "";

  techStore.$reset();
  projectStore.$reset();

  // 向服务端请求
  const logoutUrl =
    Settings.ssoServerUrl +
    "/sso/logout?service=" +
    encodeURIComponent(window.location.href);
  window.location.href = logoutUrl;
}
</script>

<style lang="scss" scoped>
.layout-home-root {
  height: 100%;
  position: relative;
}
.topnav {
  background: rgba(33, 37, 43, 0.1);
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1000;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  &:hover {
    background: rgba(33, 37, 43, 1);
    transition: 1s;
  }
}

.logo {
  width: 77px;
  height: 22px;
  background: url(/assets/images/logo.png);
  cursor: pointer;
  margin-left: 20px;
}

.router-bar {
  display: flex;
  align-items: center;
}

.text-button {
  margin: 0 14px;
  height: 30px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
}

.button-icon {
  color: #ffffff;
  margin-left: 4px;
  top: 2px;
}

.kzt-button {
  margin: 0 14px;
  border: 1px solid #fff;
  width: 70px;
  height: 30px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
  cursor: pointer;
}
</style>
